import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import DocTagSelector from '../../../cmn/DocTagSelector';
import SarasTrans from "../../../../library/notifications/SarasTrans";
import { UiTitle, UiView, UiViewContent, UiViewHeading } from '../../../../library/layout/Index';
import FormTitle from '../../../../library/form/components/FormTitle';

const RolePermTag = (props) => {
    const { formObject, viewData } = props;
    
    if(!viewData)
        return(null)

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span>
                        <FormTitle formObject={formObject} value='Permissions' />
                    </span>
                </UiTitle>
            </UiViewHeading>
            <UiViewContent>
                <div className="uiFlexBox3">
                    <span className="uiLbl">
                        <SarasTrans value="Permission Tags" />
                    </span>
                    <div className="uiDocTagSelector">
                        <DocTagSelector formObject={formObject} viewData={viewData} />
                    </div>
                </div>
            </UiViewContent>
        </UiView>
    )
}

export default withView(RolePermTag, "rolePermTag", "rolePermTag")
